import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class BikeLibraryService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  getManufacturerBike(ManufacturerSKU) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/BikeLibrary/${ManufacturerSKU}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getBikeSalePartnerDetails(SaleIdentifier) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/BikeSalePartnerInfo/${SaleIdentifier}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postBikeSaleReportEvent(SaleIdentifier, Event) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
          `/BikeSale/${SaleIdentifier}/${Event}?code=${this.env.key}`,
        {},
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
}
